/**
 * Options Wrapper Classes
 */

const optionsWrapperGeneralClasses = 'w-full py-3 box-content max-h-60 overflow-auto scrollbar mt-1';
const optionsWrapperPositionClasses = 'absolute left-0 translate-y-0.5 -translate-x-0.5 top-full z-50';
const optionsWrapperColorClasses = 'bg-white border-neutrals-300 shadow-lg rounded-lg';

/**
 * Option Classes
 */

const optionClasses =
  'flex flex-wrap items-center gap-3 px-6 py-3 cursor-pointer text-neutrals-700 site-paragraph-s font-medium hover:bg-site-primary-25';

const optionActiveClasses = 'bg-neutrals-200';
const optionSelectedClasses = 'bg-site-neutrals-50';

const optionIconClasses = 'transition-colors duration-300 fill-neutrals-800';

const optionHighlightedTextClasses = 'font-bold';

/**
 * Site Theme
 */

const inputOptionsSiteTheme = {
  optionsWrapperThemeClasses: `${optionsWrapperGeneralClasses} ${optionsWrapperPositionClasses} ${optionsWrapperColorClasses}`,
  optionThemeClasses: optionClasses,
  optionActiveThemeClasses: optionActiveClasses,
  optionSelectedThemeClasses: optionSelectedClasses,
  optionIconThemeClasses: optionIconClasses,
  optionHighlightedTextThemeClasses: optionHighlightedTextClasses,
};

export default inputOptionsSiteTheme;
